import { Hidden } from '@material-ui/core';
import { Field, FieldArray } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { employeeSearchTableStyles } from '../../../../global/constants/theme/styles/tables/employee-search-table';
import { usePendingRequests } from '../../../../global/hooks/usePendingRequests';
import { TcsmStates } from '../../../../root/tcsm-model';
import { SearchApp } from '../../../../search/components/search-app';
import { SearchList } from '../../../../search/components/search-list';
import { noSelectPersonId, PersonSearchProps } from '../../models/arc-epi-props';
import { PersonSearchItemView } from './person-search-item-view';
import { PersonSearchLabels } from './person-search-labels';
import { SearchPerson } from './person-search-model';

interface Props {
    results: SearchPerson[];
    backToTopAction: () => any;
    resultsRef: React.MutableRefObject<HTMLDivElement>;
    groupName: string;
}

export function PersonSearchResults(props: Props) {
    const { results, backToTopAction, resultsRef, groupName } = props;
    const pendingRequests = usePendingRequests();
    const personSearchProps = useSelector<TcsmStates, PersonSearchProps>(state => state.epiProps.personSearchSettingsState.epiContent);
    const tableClasses = employeeSearchTableStyles();
    const buttonClasses = buttonStyles();
    if (pendingRequests || !results || results.length < 1) return null;

    return (
        <div ref={resultsRef}>
            <ContentSpacer>
                <div className='rich-text'>
                    <h2>{personSearchProps?.searchMatchesHeader}</h2>
                    <p>{personSearchProps?.searchMatchesDescription}</p>
                </div>
            </ContentSpacer>
            {
                results?.length > 0 &&
                <ContentSpacer>
                    <FieldArray
                        name={groupName}
                        render={() => (
                            <>
                                <div data-formdata={groupName} className={tableClasses.searchTable}>
                                    <SearchApp initialList={results} appName='PersonSearch'>
                                        <Hidden xsDown>
                                            <PersonSearchLabels settings={personSearchProps} />
                                        </Hidden>
                                        <div className='employee-search-table-content'>
                                            <SearchList
                                                renderList={
                                                    (person: SearchPerson) => {
                                                        return <PersonSearchItemView settings={personSearchProps} key={person.guid} person={person} groupName={groupName} />;
                                                    }
                                                }
                                            />


                                            <div className='employee-search-table-row'>
                                                <div className='employee-search-table-row-cell no-match-cell'>
                                                    <div className='employee-search-table-radio'>
                                                        <Field type="radio" name={groupName} value={noSelectPersonId} />
                                                        <span>{personSearchProps.noMatchMessage}</span>
                                                    </div>
                                                </div>

                                                <div className='employee-search-table-row-cell'>
                                                    <button className={buttonClasses.linkButton} type='button' onClick={() => backToTopAction()}>{personSearchProps.backToTopLabel}</button>
                                                </div>
                                            </div>
                                        </div>


                                    </SearchApp>

                                </div>
                            </>
                        )}
                    />
                </ContentSpacer>
            }
        </div>
    );
}